let appointmentsRoutes = [
    {
		path: '/appointments/review',
		name: 'Review',
		meta: {
			requiresAuth: true,
            title: 'Appointment Scheduling | Appointment Portal RDCD',
            displayTitle: 'page-titles.schedule-appointments',
            layoutClass: 'layout-profile',
            requiresRoles: [ 'OWNER', 'ICT', 'OFFICIAL' ]
		},
        layout: "dashboard",
		component: () => import('../views/ReviewAppointments.vue'),
	},
    {
		path: '/schedules',
		name: 'Schedules',
		meta: {
			requiresAuth: true,
            title: 'Schedules | Appointment Portal RDCD',
            displayTitle: 'page-titles.schedules',
            layoutClass: 'layout-profile',
            requiresRoles: [ 'OWNER', 'ICT', 'OFFICIAL' ]
		},
        layout: "dashboard",
		component: () => import('../views/appointments/Schedules.vue'),
	},
    {
		path: '/appointments',
		redirect: '/appointments/today-online',
        layout: "dashboard",
		component: () => import('../views/appointments/AppointmentGrid.vue'),
	},
    {
		path: '/appointments/:type',
		name: 'Appointments',
		meta: {
			requiresAuth: true,
            title: 'Appointments | Appointment Portal RDCD',
            displayTitle: 'page-titles.appointments',
            layoutClass: 'layout-profile',
            requiresRoles: [ 'OWNER', 'ICT', 'OFFICIAL' ]
		},
        props: true,
        layout: "dashboard",
		component: () => import('../views/appointments/AppointmentGrid.vue'),
	},
];

export { appointmentsRoutes };